import axios from '@/axios';

export default {
	namespaced: true,

	state: {
		tests: [],
	},

	actions: {
		fetchAll({ commit }, { specialtyId, conceptId, courseId, page, perPage }) {
			return axios.get('/examTest/searchTest', {
				params: {
					specialtyId,
					conceptId,
					courseId,
					page,
					perPage,
				}
			}).then(({ data }) => {
				return { data: data.items, total: data.totalCount };
			})
		},

		fetchAllByCourse({ commit }, { conceptId, courseId, page, perPage }) {
			return axios.get('/examTest/searchCourse', {
				params: {
					conceptId,
					courseId,
					page,
					perPage,
				}
			}).then(({ data }) => {
				return { data: data.items, total: data.totalCount };
			})
		},

		fetchById({ commit }, { id }) {
			return axios.get(`/examTest/0/${id}`).then(({ data }) => {
				return data;
			})
		},

		create({ commit }, { name, courseId, conceptId, topicTests, testDateTime, maxGrade, dateTime }) {
			return axios.post('/examTest', { name, courseId, conceptId, topicTests, testDateTime, maxGrade, dateTime }).then(({ data }) => data);
		},

		update({ commit }, { id, name, courseId, conceptId, topicTests, testDateTime, maxGrade, dateTime }) {
			return axios.put(`/examTest/0/${id}`, { name, courseId, conceptId, topicTests, testDateTime, maxGrade, dateTime }).then(({ data }) => data);
		},

		fetchQuestions({ commit }, { id }) {
			return axios.get(`/questionTest/0/test/${id}/question-tests`).then(({ data }) => data);
		},

		updateQuestions({ commit }, { testId, questions }) {
			const formData = new FormData();
			
			questions.forEach((c, i) => {
				formData.append(`questionTestRequest[${i}].displayOrder`, i);
				if (c.type || c.question?.type) {
					formData.append(`questionTestRequest[${i}].questionType`, c.type || c.question?.type);
				}
				if (c.questionId) {
					formData.append(`questionTestRequest[${i}].questionId`, c.questionId);
					formData.append(`questionTestRequest[${i}].degree`, c.degree);
				} else if (c.question) {
					if (c.question.name) {
						formData.append(`questionTestRequest[${i}].question.name`, c.question.name)
					} else if (c.question.questionImages) {
						c.question.questionImages.forEach((img, j) => {
							if (img.id) {
								formData.append(
									`questionTestRequest[${i}].question.questionImages[${j}].id`,
									img.id
								);
							}
							if (img.image) {
								formData.append(
									`questionTestRequest[${i}].question.questionImages[${j}].${
										typeof img.image === 'string'
											? 'imageUrl'
											: 'image'
									}`,
									img.image
								);
							}
							if (img.imageData) {
								formData.append(
									`questionTestRequest[${i}].question.questionImages[${j}].imageData`,
									img.imageData
								);
							}
						})
					}
				}
			})
			return axios.post(`/questionTest/0/test/${testId}/questions`, formData).then(({ data }) => data);
		},
	},
}